import ConnectedRentalCarNewContainer from './ConnectedRentalCarNewContainer'
import RentalCarNewContainer from './RentalCarNewContainer'
export {
    RentalCarNewContainer,
}
export default ConnectedRentalCarNewContainer
